import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import { Content, Header } from 'antd/es/layout/layout';
import PageHeader from '../../components/PageHeader';
import { Button, Card, Divider, Form, Input, InputNumber, Modal, Radio, Select, Space, Table, Typography, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { CloseOutlined, EditRounded } from '@mui/icons-material';
import Title from 'antd/es/typography/Title';
import useAxios from 'axios-hooks';
import { BASE_URL, titleCase } from '../../utils/Common';
import { createLocation, getLocations, updateLocation } from '../../api/locationsApi';
const { Option } = Select;

export default function Location() {
  const [locationForm] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState("add");
  const [temperatureType, setTemperatureType] = useState("exact");
  const [initialValues, setInitialValues] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const toaster = (type, content) => {
    messageApi.open({ type, content: titleCase(content) });
  };

  const onClickAddLocation = () => {
    setFormType("add");
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    locationForm.resetFields();
  };
  const onFinish = async (values) => {
    setSaving(true);
    if (formType === "add") {
      const res = await createLocation(values);
      console.log(res, values);
      if (res.data){
        setShowForm(false);
        toaster('success', res.data.message);
        locationForm.resetFields();
        _getLocations();
      } else if (res.error) {
        console.log(res.error.data.messages.error_messages[0]);        
        toaster('error', res.error.data.messages.error_messages[0]);        
      }
    } else if (formType === "edit") {
      // alert(JSON.stringify(values));
      const res = await updateLocation(values);
      if (res.data) {
        console.log(res.data.message);
        setShowForm(false);
        toaster('success', res.data.message);
        locationForm.resetFields();
        _getLocations();
      } else if (res.error) {
        console.log(res.error.data.messages.error_messages[0]);        
        toaster('error', res.error.data.messages.error_messages[0]);        
      }
    }
    setSaving(false);
  };

  const onChangeTemperatureType = (value) => {
    setTemperatureType(value);
  }

  function handleEdit(record) {
    // locationForm.resetFields();
    console.log(record)
    var _levels = record.rack_levels?.map(level => {
      return ({
        rack_level_id: level.id,
        level: level.level,
        maximum_qty: level.maximum_qty,
        temperature_type: level.temperature_type,
        temperature: level.temperature,
        // temperature_to: level.temperature_to,
        // temperature_from: level.temperature_from,
      })
    })
    var _initialValues = {
      rack_id: record.id,
      name: record.name,
      row: record.row,
      column: record.column,
      remarks: record.remarks,
      levels: _levels || []    
    }

    locationForm.setFieldsValue(_initialValues);
    setShowForm(true);
  }

  // Get locations
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  async function _getLocations() {
    setLoading(true);
    const res = await getLocations();
    if (res.data) {
      console.log('get loc', res.data);
      setLocations(res.data)
    } else {
      console.log(res.error);
    }
    setLoading(false);
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
      ellipsis: true,
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
      ellipsis: true,
    },
    // {
    //   title: 'Action',
    //   key: 'operation',
    //   render: () => {
    //     return(
    //     <Space>
    //       <Button>Edit</Button>
    //       <Button danger>Delete</Button>
    //     </Space>
    //     )
    //   },
    //   responsive: ['md']
    // },
  ];

  useEffect(() => {
    document.title = "Location";
    _getLocations();
  }, []);

  return (
    <Layout>
      <PageHeader title="Location" buttonTitle="Add location" onClick={onClickAddLocation} />
      {contextHolder}
      <Content>
        <Table 
          size='small' 
          columns={columns} 
          dataSource={locations} 
          loading={loading}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => {setFormType("edit"); handleEdit(record); },
            };
          }}
        />
      </Content>
      <Modal 
        footer={null} 
        title={formType === "add" ? `Add location` : `Edit location`} 
        open={showForm} 
        onCancel={handleCancel}
      >
        <Form 
          name="location-form" 
          form={locationForm} 
          layout='vertical' 
          onFinish={onFinish}
          initialValues={initialValues}
        >
          <Form.Item hidden name="rack_id" label="ID:"> <Input disabled /> </Form.Item>
          <Space className='w-full'>
            <Form.Item className='w-full' name="name" label="Name:">
              <Input placeholder="Ex. Aisle 35" />
            </Form.Item>
            <Form.Item name="row" label="Row:">
              <InputNumber />
            </Form.Item>
            <Form.Item name="column" label="Column:">
              <InputNumber />
            </Form.Item>
          </Space>
          <Form.Item name="remarks" label="Remarks:">
            <TextArea rows={2} />
          </Form.Item>

          <Divider/>

          <Title level={5} >Add rack levels</Title>

          <Form.List name="levels">
            {(fields, { add, remove }) => (
              <div
                style={{
                  display: 'flex',
                  rowGap: 16,
                  flexDirection: 'column',
                }}
              >
                <Button type="dashed" onClick={() => add()} block>
                  + Add rack level
                </Button>

                {fields.map((field) => (
                  <Card
                    key={field.key}
                    size="small"
                    title={`Level`}
                    extra={
                      <CloseOutlined
                        color='gray'
                        onClick={() => {
                          remove(field.name);
                        }}
                      />
                    }
                  >
                    <Form.Item label="Level #:" name={[field.name, 'level']}>
                      <InputNumber style={{width:'100%'}}/>
                    </Form.Item>
                    <Space className='flex w-full'>
                      <Form.Item label="Max. Capacity:" name={[field.name, 'maximum_qty']}>
                        <InputNumber style={{width: '100%'}} />
                      </Form.Item>
                      <Form.Item label="Temperature:" name={[field.name, 'temperature']}>
                        <InputNumber style={{width: '100%'}} />
                      </Form.Item>
                    </Space>

                    {/* <p>Temperature:</p>
                    <Space className='mt-2'>
                      <Form.Item noStyle name={[field.name, 'temperature_type']}>
                        <Select style={{ width: 150 }}>
                          <Option value="exact">Exactly</Option>
                          <Option value="higher">Higher than</Option>
                          <Option value="lower">Lower than</Option>
                          <Option value="in-range">In range of</Option>
                        </Select>
                      </Form.Item>
                       <Form.Item noStyle name={[field.name, 'temperature_from']}>
                          <InputNumber placeholder='Min' />
                        </Form.Item>
                        -
                        <Form.Item noStyle name={[field.name, 'temperature_to']}>
                          <InputNumber placeholder='Max'/>
                        </Form.Item>
                    </Space> */}
                  </Card>
                ))} 

              </div>
            )}
          </Form.List>


          {/* <Form.Item noStyle shouldUpdate>
            {() => (
              <Typography>
                <pre>{JSON.stringify(locationForm.getFieldsValue(), null, 2)}</pre>
              </Typography>
            )}
          </Form.Item> */}
          {/* {console.log(locationForm.getFieldsValue())} */}
          
          <Divider/>

          <Space className='flex justify-end mt-5'>
            <Form.Item>
              <Button htmlType="button" className='mr-1' onClick={()=>locationForm.resetFields()}>
                Reset
              </Button>
              <Button className='bg-green-500 ml-1' type="primary" htmlType="submit" loading={saving}>
                Save
              </Button>
            </Form.Item>
        </Space>
        </Form>
      </Modal>
    </Layout>
  )
}
